
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/survey/v30/welcome",
      function () {
        return require("private-next-pages/survey/v30/welcome/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/survey/v30/welcome"])
      });
    }
  